export default "__VITE_ASSET__24043232__"